import { render } from "./messaging-service-configuration-form-criteria-section.vue?vue&type=template&id=35a7287b&scoped=true&ts=true"
import script from "./messaging-service-configuration-form-criteria-section.vue?vue&type=script&lang=ts"
export * from "./messaging-service-configuration-form-criteria-section.vue?vue&type=script&lang=ts"

import "./messaging-service-configuration-form-criteria-section.vue?vue&type=style&index=0&id=35a7287b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a7287b"]])

export default __exports__